/* global squiz */

let carouselConfigs = {};

const initCarousel = (storyCarousel, Glide, Controls, Breakpoints, Swipe) => {
    const id = storyCarousel.dataset.glideSliderId;
    if (storyCarousel.querySelectorAll(".glide__slide").length > 3) {
        carouselConfigs[id] = new Glide(storyCarousel, {
            type: "carousel",
            startAt: 0,
            perView: 3,
            gap: 30,
            breakpoints: {
                1199: {
                    perView: 2,
                },
                767: {
                    perView: 1,
                },
            },
        });

        // turn off loading screan
        carouselConfigs[id].on("mount.after", function () {
            storyCarousel
                .querySelector(".glide__track")
                .classList.remove("loading");
        });
        // render carousel or not - depending on resolution
        if (window.innerWidth >= squiz.vars.desktopWidth) {
            carouselConfigs[id].mount({ Controls, Breakpoints, Swipe });
        } else {
            storyCarousel
                .querySelector(".glide__track")
                .classList.remove("loading");
        }
    }
};

const carousel = () => {
    const carousels = document.querySelectorAll(
        ".glide[data-glide-story-carousel-id]"
    );
    const carouselsNone = document.querySelectorAll(".glide-none");

    if (carousels && carousels.length > 0) {
        // Support for IntersectionObserver
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const storyCarousel = entry.target;
                            import("@glidejs/glide/dist/glide.modular.esm")
                                .then(({ default: Glide, Controls, Breakpoints, Swipe }) => {
                                    initCarousel(storyCarousel, Glide, Controls, Breakpoints, Swipe);
                                })
                                .catch((error) => console.error("Error loading Glide.js", error));
                            observer.unobserve(storyCarousel);
                        }
                    });
                },
                { rootMargin: "200px 0px" }
            );

            Array.from(carousels).forEach((storyCarousel) => {
                observer.observe(storyCarousel);
            });
        } else {
            // Fallback for IE11 or older browsers
            import("@glidejs/glide/dist/glide.modular.esm")
                .then(({ default: Glide, Controls, Breakpoints, Swipe }) => {
                    Array.from(carousels).forEach((storyCarousel) => {
                        initCarousel(storyCarousel, Glide, Controls, Breakpoints, Swipe);
                    });
                })
                .catch((error) => console.error("Error loading Glide.js", error));
        }
    }

    if (carouselsNone) {
        Array.from(carouselsNone).forEach((storyCarousel) => {
            storyCarousel
                .querySelector(".glide__track")
                .classList.remove("loading");
        });
    }
};

export default carousel;
